var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" "+_vm._s(_vm.item.toelichting)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }